"use strict";
var cachingConfigurationProvider_1 = require("./cachingConfigurationProvider");
var SPListConfigurationProvider = (function () {
    function SPListConfigurationProvider(sourceWeb, sourceListTitle) {
        if (sourceListTitle === void 0) { sourceListTitle = "config"; }
        this.sourceWeb = sourceWeb;
        this.sourceListTitle = sourceListTitle;
    }
    Object.defineProperty(SPListConfigurationProvider.prototype, "web", {
        get: function () {
            return this.sourceWeb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SPListConfigurationProvider.prototype, "listTitle", {
        get: function () {
            return this.sourceListTitle;
        },
        enumerable: true,
        configurable: true
    });
    SPListConfigurationProvider.prototype.getConfiguration = function () {
        return this.web.lists.getByTitle(this.listTitle).items.select("Title", "Value")
            .getAs().then(function (data) {
            var configuration = {};
            data.forEach(function (i) {
                configuration[i.Title] = i.Value;
            });
            return configuration;
        });
    };
    SPListConfigurationProvider.prototype.asCaching = function () {
        var cacheKey = "splist_" + this.web.toUrl() + "+" + this.listTitle;
        return new cachingConfigurationProvider_1.default(this, cacheKey);
    };
    return SPListConfigurationProvider;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SPListConfigurationProvider;
